import { Link } from "react-router-dom";

export function LegalLinks({ testId = "legal-links", className = "" }) {
  const cls = "font-medium text-[#2B7F77] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded";
  return (
    <nav aria-label="Legal" data-testid={testId} className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500 ${className}`}>
      <Link to="/terms" data-testid={`${testId}-terms`} className={cls}>Terms of Use</Link>
      <span aria-hidden="true" className="text-slate-300">·</span>
      <Link to="/privacy" data-testid={`${testId}-privacy`} className={cls}>Privacy Policy</Link>
    </nav>
  );
}
